import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function InfoFilledIcon({ width, height, viewBox = '0 0 24 24', style, className }: IIcon) {
    return (
        <Icon width={width} height={height} viewBox={viewBox} style={style} className={className}>
            <>
                <g clipPath="url(#clip0_2_292)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.8501 10.7501C10.8501 10.115 11.365 9.6001 12.0001 9.6001C12.6352 9.6001 13.1501 10.115 13.1501 10.7501V17.1501C13.1501 17.7852 12.6352 18.3001 12.0001 18.3001C11.365 18.3001 10.8501 17.7852 10.8501 17.1501V10.7501ZM12.0001 7.3C12.6352 7.3 13.1501 6.78513 13.1501 6.15C13.1501 5.51487 12.6352 5 12.0001 5C11.365 5 10.8501 5.51487 10.8501 6.15C10.8501 6.78513 11.365 7.3 12.0001 7.3Z"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2_292">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </>
        </Icon>
    );
}
